import eLife from '@/views/eLife'

export default {
  path: '/eLife',
  component: eLife,
  name: 'eLife',
  meta: {
    title: '我的'
  },
  children: [
    {
      path: 'policy',
      component: () => import('@/views/eLife/Policy'),
      name: 'Policy',
      meta: {
        title: '基本信息'
      }
    }
  ]
}
